import { login, LoginRequest } from '@/services/auth'
import {
  createUser,
  CreateUserRequest,
  fetchUser,
  updateUser,
  updateUserPassword,
} from '@/services/user'
import { getToken, setToken, unsetToken } from '@/utils/token'
import { getUser, setUser, unsetUser } from '@/utils/user'

import {
  AuthActions,
  AuthUpdateUserActionPayload,
  AuthUpdateUserPasswordActionPayload,
} from './types'

const actions: AuthActions = {
  async login({ commit }, payload: LoginRequest) {
    const response = await login(payload)

    setToken(response.token.accessToken)
    setUser(response.user)

    commit('setAccessToken', response.token.accessToken)
    commit('setUser', response.user)
  },
  async register({ commit }, payload: CreateUserRequest) {
    await createUser(payload)
    const response = await login({ email: payload.email, password: payload.password })

    setToken(response.token.accessToken)
    setUser(response.user)

    commit('setAccessToken', response.token.accessToken)
    commit('setUser', response.user)
  },
  async logout({ commit }) {
    unsetToken()
    unsetUser()

    commit('setAccessToken', null)
    commit('setUser', null)
  },
  async fetchIfAuthenticated({ commit }): Promise<void> {
    const user = getUser()
    const token = getToken()

    if (!user || !token) {
      return
    }

    setUser(user)
    setToken(token)

    try {
      const response = await fetchUser({ id: user.id })

      setUser(response)
      commit('setUser', response)
    } catch (error) {
      unsetToken()
      unsetUser()

      commit('setAccessToken', null)
      commit('setUser', null)
    }
  },
  async updateUser({ commit, state }, payload: AuthUpdateUserActionPayload): Promise<void> {
    if (!state.user) {
      return
    }

    const user = await updateUser({ ...payload, id: state.user.id })

    setUser(user)
    commit('setUser', user)
  },
  async updateUserPassword({ state }, payload: AuthUpdateUserPasswordActionPayload): Promise<void> {
    if (!state.user) {
      return
    }

    await updateUserPassword({ ...payload, id: state.user.id })
  },
}

export default actions
